module.exports = __webpack_public_path__ + "static/img/upload.0b617fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/components/c2cPopup/img/upload.png
// module id = wTdJ
// module chunks = 43